import useBreadcrumbs from 'use-react-router-breadcrumbs';

import { AppRoutes } from '../../interfaces';
import { useAppRouter } from './useAppRouter';

export const useAppBreadcrumb = (): {
  breadcrumb: ReturnType<typeof useBreadcrumbs>;
  routesToDisable: Set<string>;
} => {
  const {
    routes: { common: commonRoutes, drawer: drawerRoutes }
  } = useAppRouter();

  const routesToDisable = new Set([
    '/domains-api/cloudflare',
    '/domains-api/search-console',
    '/domains-api',
    AppRoutes.PageNodes,
    AppRoutes.PageNodesById,
    AppRoutes.SiteSearchConsole
  ]);

  const breadcrumb = useBreadcrumbs([...commonRoutes, ...drawerRoutes], {
    excludePaths: [
      '/sites/view',
      '/site-groups/view',
      AppRoutes.PageNodes,
      '/sites/view/:siteId/pages/create',
      '/domains-api/search-console/accounts/create/:searchConsoleAccountId'
    ]
  });

  return { breadcrumb, routesToDisable };
};
